
export const loadCartItems = () => {
    const list = localStorage.getItem('cart');
    return JSON.parse(list);
}

export const getWishListItems = () => {
    const list = localStorage.getItem('wishlist');
    return JSON.parse(list);
}